import {
  REQUEST_SERVICE_ESTIMATE,
  RECEIVE_SERVICE_ESTIMATE,
  SET_SERVICE_ESTIMATE_TIMEOUT,
  UNSET_SERVICE_ESTIMATE_TIMEOUT,
} from 'ondemand/actions/serviceEstimate';

export default function serviceEstimate(
  state = {
    agencyId: null,
    isFetching: false,
    item: null,
    timeout: null,
    serviceId: null,
  },
  action,
) {
  switch (action.type) {
    case REQUEST_SERVICE_ESTIMATE:
      return Object.assign({}, state, {isFetching: true});
    case RECEIVE_SERVICE_ESTIMATE:
      return Object.assign({}, state, {
        agencyId: action.agencyId,
        isFetching: false,
        item: action.serviceEstimate,
        serviceId: action.serviceId,
      });
    case SET_SERVICE_ESTIMATE_TIMEOUT:
      return Object.assign({}, state, {timeout: action.timeout});
    case UNSET_SERVICE_ESTIMATE_TIMEOUT:
      return Object.assign({}, state, {timeout: null});
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/ondemand/reducers/serviceEstimate.js